import { h, Component, Prop, State } from '@stencil/core';
import type { ComponentInterface } from '@stencil/core';

@Component({
	tag: 'app-speedbump',
	styleUrl: 'speedbump.scss'
})
export class Speedbump implements ComponentInterface {
	appDialog?: HTMLAppDialogElement;

	@Prop() speedbumpId?: string;

	@State() open = false;

	componentDidLoad() {
		let speedbumpLink: HTMLAnchorElement | undefined;

		addEventListener('click', e => {
			if (this.open)
				return;

			speedbumpLink = e.composedPath()
				.find<HTMLAnchorElement>((node: Node): node is HTMLAnchorElement =>
					node instanceof HTMLAnchorElement &&
					node.classList.contains('speedbump-link')
				);
			if (!speedbumpLink)
				return;

			const sameId =  this.speedbumpId === speedbumpLink.dataset.speedbumpId;
			const   noId = !this.speedbumpId && !speedbumpLink.dataset.speedbumpId;
			if (!sameId && !noId)
				return;

			e.preventDefault();
			this.open = true;
		});

		this.appDialog!.addEventListener('appDialogReturn', ({ detail: returnValue }: CustomEvent<string>) => {
			if (returnValue !== 'confirm')
				return;

			speedbumpLink!.classList.remove('speedbump-link');
			delete speedbumpLink!.dataset.speedbumpLink;
			speedbumpLink!.click();
		});
	}

	render() {
		return (
			<app-dialog
				ref={e => this.appDialog = e}
				modal
				open={this.open}
				onAppDialogToggled={({ detail: open }) => {
					this.open = open;
				}}
			>
				<slot slot='header' name='header' />
				<slot />
				<footer slot='footer'>
					<form method='dialog'>
						<button class='btn btn-primary' value='cancel'>
							<slot name='cancel'>Return</slot>
						</button>
						<button class='btn btn-secondary' value='confirm'>
							<slot name='confirm'>Continue</slot>
						</button>
					</form>
				</footer>
			</app-dialog>
		);
	}
}
